angular.module('elfium').controller('businessCaseNewModalController', ['$scope', '$uibModalInstance', '$timeout', '$q', 'businessCaseService', 'reportContentService', 'elfiumToastrService', 'elfiumRelatedOptionsService', 'elfiumUrlService', 'elfiumLoginService', 'elfiumMissingRequiredFieldsFilter', 'ELFIUM_SELECT_OPTIONS', 'BUSINESS_CASE_REQUIRED_FIELDS', 'TASK_REQUIRED_FIELDS', 'TASK_STATES', 'TASK_TYPES',
    function ($scope, $uibModalInstance, $timeout, $q, businessCaseService, reportContentService, elfiumToastrService, elfiumRelatedOptionsService, elfiumUrlService, elfiumLoginService, elfiumMissingRequiredFieldsFilter,  ELFIUM_SELECT_OPTIONS, BUSINESS_CASE_REQUIRED_FIELDS, TASK_REQUIRED_FIELDS, TASK_STATES, TASK_TYPES) {
        var that = this;
        $scope.stepTemplates = {
            stepOne: elfiumUrlService.getTemplateUrl('businessCase', 'businessCaseNewModalOne'),
            stepTwo: elfiumUrlService.getTemplateUrl('businessCase', 'businessCaseNewModalTwo'),
            stepThree: elfiumUrlService.getTemplateUrl('businessCase', 'businessCaseNewModalThree')
        };
        $scope.canChangeBusinessCaseAndStatus = false;
        $scope.businessCaseDetailModalBody = elfiumUrlService.getTemplateUrl('businessCase', 'businessCaseDetailModalBody');
        $scope.taskDetailModalBody = elfiumUrlService.getTemplateUrl('task', 'taskDetailModalBody');
        $scope.selectOptions = ELFIUM_SELECT_OPTIONS;
        $scope.taskTypeOptions = TASK_TYPES;
        $scope.businessCase = {
            userId: elfiumLoginService.getUserId()
        };
        $scope.task = {
            obchodniPripadId: 'placeholder id',
            stav: TASK_STATES.NAPLANOVANO,
        };
        $scope.reports = {
            updateReportsCallback: $q.resolve
        };
        that.initialize = function () {
            that.getRelatedOptions();
            $scope.goGoToPageOne();
        };
        that.getRelatedOptions = function () {
            elfiumRelatedOptionsService.getCompanyOptions().then(function (companyOptions) {
                $scope.companyOptions = companyOptions;
            }, elfiumToastrService.error);
            elfiumRelatedOptionsService.getUserOptions().then(function (userOptions) {
                $scope.userOptions = userOptions;
            }, elfiumToastrService.error);
        };
        that.getRelatedContactOptionsForCompany = function (companyId) {
            elfiumRelatedOptionsService.getContactOptionsForCompany(companyId).then(function (contactOptions) {
                $scope.contactOptions = contactOptions;
            }, elfiumToastrService.error);
        };

        that.createBusinessCaseAndTask = function () {
            businessCaseService.createBusinessCaseAndTask($scope.businessCase, $scope.task).then(function () {
                return $scope.reports.updateReportsCallback($scope.businessCase.id);
            }).then(function () {
                elfiumToastrService.success('Obchodní případ a úkol vytvořeny');
                $uibModalInstance.close();
            }, elfiumToastrService.error);
        };
        $scope.isStepOne = function () {
            return that.currentPage === 1;
        };
        $scope.isStepTwo = function () {
            return that.currentPage === 2;
        };
        $scope.isStepThree = function () {
            return that.currentPage === 3;
        };
        $scope.goGoToPageOne = function () {
            that.currentPage = 1;
        };
        $scope.goGoToPageTwo = function () {
            $timeout(function () {
                var missingRequiredFields = elfiumMissingRequiredFieldsFilter($scope.businessCase, BUSINESS_CASE_REQUIRED_FIELDS);
                if (missingRequiredFields.length) {
                    elfiumToastrService.error('Vyplňte povinné údaje: ' + missingRequiredFields.join(', '));
                } else {
                    $scope.task.kontaktId = $scope.task.kontaktId || $scope.businessCase.kontaktId;
                    $scope.task.userId = $scope.task.userId || $scope.businessCase.userId;
                    that.currentPage = 2;
                }
            });
        };
        $scope.goGoToPageThree = function () {
            $timeout(function () {
                if (reportContentService.hasFirstItemInActual($scope.reports.reportsByTypes)) {
                    that.currentPage = 3;        
                } else {
                    elfiumToastrService.error('Vyplňte povinné údaje: Realita/0-K Otevření/Otevření případu');
                }
            });
        };        
        $scope.$watch('businessCase.firmaId', function (newValue) {
            if (newValue) {
                that.getRelatedContactOptionsForCompany(newValue);
            }
        });
        $scope.okClicked = function () {
            $timeout(function () {
                var missingRequiredFields = elfiumMissingRequiredFieldsFilter($scope.task, TASK_REQUIRED_FIELDS);
                if (missingRequiredFields.length) {
                    elfiumToastrService.error('Vyplňte povinné údaje: ' + missingRequiredFields.join(', '));
                } else {
                    that.createBusinessCaseAndTask();
                }
            });
        };
        that.initialize();
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/businessCase/businessCaseNewModalController.ts